import { render, staticRenderFns } from "./Kusama.vue?vue&type=template&id=6f128ea0&scoped=true&"
import script from "./Kusama.vue?vue&type=script&lang=js&"
export * from "./Kusama.vue?vue&type=script&lang=js&"
import style0 from "./Kusama.vue?vue&type=style&index=0&id=6f128ea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f128ea0",
  null
  
)

export default component.exports